import React, { useEffect, useState } from "react";

import { ChevronRight as RightArrow } from "@styled-icons/bootstrap";
import { ChevronLeft as LeftArrow } from "@styled-icons/bootstrap";

import {
  Root,
  Footer,
  CurrentCardNumber,
  PreviousButton,
  NextButton
} from "./styles";
import { RoomCard } from "../RoomCard";

import { IHouse } from "interfaces/intarfaces";

interface IRoomCardsNavigator {
  houses: IHouse[];
  onClose: () => void;
  onChange?: (house: IHouse) => void;
  onRoomClick: (house: IHouse) => void;
  onLikedChanged: (house: IHouse) => void;
}

export const RoomCardsNavigator: React.FC<IRoomCardsNavigator> = ({
  houses,
  onClose,
  onChange,
  onRoomClick,
  onLikedChanged
}) => {
  const [activeHouse, setActiveHouse] = useState(0);

  const housesListHash = houses.map((h) => h.house_id).join(", ");

  useEffect(() => {
    setActiveHouse(0);
  }, [housesListHash]);

  return (
    <Root>
      {houses[activeHouse] && (
        <RoomCard
          key={houses[activeHouse].house_id}
          house={houses[activeHouse]}
          onClose={onClose}
          onClick={onRoomClick}
          onLikedChanged={onLikedChanged}
        />
      )}
      <Footer>
        <PreviousButton
          disabled={activeHouse === 0}
          onClick={() => {
            setActiveHouse(activeHouse - 1);
            onChange?.(houses[activeHouse - 1]);
          }}
        >
          <LeftArrow />
        </PreviousButton>
        <CurrentCardNumber>
          {activeHouse + 1} of {houses.length}
        </CurrentCardNumber>
        <NextButton
          disabled={activeHouse === houses.length - 1}
          onClick={() => {
            setActiveHouse(activeHouse + 1);
            onChange?.(houses[activeHouse + 1]);
          }}
        >
          <RightArrow />
        </NextButton>
      </Footer>
    </Root>
  );
};
